// extracted by mini-css-extract-plugin
export default {"container":"sk-z","blurb":"tk-z","links":"uk-z"};